module.exports = __webpack_public_path__ + "static/media/octobotlogo.3a5f3030.webp";